exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@firebase/polyfill/node_modules/core-js/internals/object-get-own-property-symbols.js
// module id = 183
// module chunks = 0